import { render, staticRenderFns } from "./ApfBasicInput.vue?vue&type=template&id=5c675c2a&scoped=true"
import script from "./ApfBasicInput.vue?vue&type=script&lang=js"
export * from "./ApfBasicInput.vue?vue&type=script&lang=js"
import style0 from "./ApfBasicInput.vue?vue&type=style&index=0&id=5c675c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c675c2a",
  null
  
)

export default component.exports